import { render } from "./EventsList.vue?vue&type=template&id=6ecbfaa3&scoped=true&ts=true"
import script from "./EventsList.vue?vue&type=script&lang=ts"
export * from "./EventsList.vue?vue&type=script&lang=ts"

import "./EventsList.vue?vue&type=style&index=0&id=6ecbfaa3&lang=stylus&scoped=true"

import exportComponent from "/builds/web-factory/barsmart/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ecbfaa3"]])

export default __exports__